'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

/* injects from baggage-loader */

var logo = ['data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA', '/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAABzUlEQVRo3mNgGAWjYBSMglEwkgHjQFp', '+T4v7P7qY0rWvJLmJBcVA7uL/pDpC6WsvVQPhvxcDUW5g3AYJfBaKLbSxRrGQ8chRusYq01DPAyz0tOz', '/IY7/DP8REXY/czQGhlES+t/A8J+BoRe/6lNEliKMDAyMW+lTRLMMZOgpChlgCn4ioghFKulo44G/nAz/', 'bYwwy/N3lxkYBH8OXAzcD+AmSh3rZ3YGmfWjmZi0GGBsYGD8f5AdfzV+c7QYpW1rlFAM3L9JXJZh/', 'fuPQebld5Icwu1UhFV8g94+rOJuAhdIb8zpaKTjlAuTXAhnS3z+y9C+6ftoEhr1wKgH6FkPJNwW', '/p+IJrn2yAsUPjOa/OdEVkQpdlsYXoLdZVVl4JM/hmhZKNYxMDChNiG+2fWhlIBcTgz/', 'KfLAYAWBaeswxL6uUmIcGV3KiYsIRJDj//9J+xkZB60HSAELVN/CPcK/6M1/BoY/ROvVFVz', '/n8Efu9w910GQBxinpzHAOvPI6XfI98iIAZNfK+', 'JNuizISYA77B5KUWZHJUfweCswvIyjTV7BGwP9Fzbg1Xz5fSDjQMfQ6MgcNvARLbl8H', 'q7DKsSAga5nRsEoGAWjYBQMbgAAp3F2HkPexT4AAAAASUVORK5CYII='].join('');

exports.default = logo;


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectShareRenderer/logo.js
// module id = 592
// module chunks = 1